






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Header extends Vue {
  @Prop(Boolean)
  readonly sidebarCollapsed?: boolean

  get type() {
    return this.sidebarCollapsed ? 'menu-unfold' : 'menu-fold'
  }

  onBurgerClick() {
    this.$emit('update:sidebarCollapsed', !this.sidebarCollapsed)
  }
}
